export const VEHICLE_TOWING_DEFAULT_VALUES = {
  IsTowed: false,
  ptsDriverID: null,
  ptsPlaceID: null,
  ptsEventID: null,
};
